var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documentBlock"},_vm._l((_vm.items),function(el,index){return _c('div',{key:index},[_c('div',{domProps:{"innerHTML":_vm._s(el.name)}}),_c('div',{domProps:{"innerHTML":_vm._s(el.content)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }